import { render, staticRenderFns } from "./Wizard-2.vue?vue&type=template&id=6ffc5f03"
import script from "./Wizard-2.vue?vue&type=script&lang=js"
export * from "./Wizard-2.vue?vue&type=script&lang=js"
import style0 from "./Wizard-2.vue?vue&type=style&index=0&id=6ffc5f03&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports